export default __webpack_public_path__ + "static/lozenge-dropdown-trigger-do-533a4533bafa706a2f1ea28059cab7867d5d1c7a580eb94a60b538b18c6e4f3b.png";